module.exports = __webpack_public_path__ + "img/qy (20).29b10242.jpg";